export const deleteFail: string = 'Не удалось удалить аватар';
export const deleteOk: string = 'Удаление аватара прошло успешно';
